import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RetoTcPage } from './reto-tc';
// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
@NgModule({
  declarations: [
    RetoTcPage,
  ],
  imports: [
    IonicPageModule.forChild(RetoTcPage),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
  ],
})
export class RetoTcPageModule {}



// WEBPACK FOOTER //
// ./src/pages/team-challenge/reto-tc/reto-tc.module.ts